<div style="text-align:right">
    <button #LinkCustomerBtn mat-raised-button class="action-button-size" color="primary" *ngIf="linkCustomer"
        (click)="linkedCustomer()"> Link ID </button>
    <!-- <button  *ngIf="isPreviewEnabled" #previewBtn mat-raised-button class="action-button-size" style="background-color: sandybrown;" (click)="preview()"
        [disabled]="isPreviewEnabled === false || model?.preview === true && isSameDay === false" >Preview</button>  -->
    <button #cancelBtn mat-raised-button class="action-button-size" (click)="cancel()">Cancel</button>
    <!-- <button #deleteBtn mat-raised-button class="action-button-size" color="warn" (click)="delete()"
        [disabled]="isDeleteEnabled === false || model?.authorised === true && isSameDay === false">Delete</button>
     -->
      <button #deleteBtn mat-raised-button class="action-button-size" color="warn"
          *ngIf="showDelete"
          (click)="delete()"
          [disabled]="isDeleteEnabled === false || model?.authorised === true && isSameDay === false">
    Delete
  </button>
    
        <button  #authoriseBtn mat-raised-button class="action-button-size" color="accent"   
        *ngIf="showAuthorise"
        (click)="authorise()"
        [disabled]="isAuthoriseEnabled === false || model?.authorised === true">Approve</button>
    <!-- <button #saveBtn mat-raised-button class="action-button-size" color="primary" (click)="save()"
        [disabled]="isSaveEnabled === false">Save</button> -->

        <!-- <button #saveBtn mat-raised-button class="action-button-size" color="primary"
        (click)="save()" [disabled]="!isSaveEnabled">Save</button> -->

          <!-- <button #saveBtn mat-raised-button class="action-button-size" color="primary"
          *ngIf="showSave || disableSave"
          (click)="save()"
          [disabled]="!isSaveEnabled">
    Save
  </button> -->

  <button #saveBtn mat-raised-button class="action-button-size"
  color="primary" *ngIf="showSave || disableSave"
  (click)="save()" [disabled]="disableSave || !isSaveEnabled">
  Save
</button>
</div>